import LocalizedStrings from 'react-localization';
import se from 'languages/se';

const baseContent = {se};

const strings = new LocalizedStrings(baseContent);

export const applyOverrides = (overrides = {}) => {
	const currentLang = strings.getLanguage();
	const merged = Object.keys(baseContent).reduce((acc, locale) => {
		const {_meta, ...localeOverrides} = overrides[locale] || {};
		// Deep-clone nested base, then substitute each flat override key into its namespace
		const nested = JSON.parse(JSON.stringify(baseContent[locale]));
		for (const [key, value] of Object.entries(localeOverrides)) {
			for (const ns of Object.values(nested)) {
				if (ns && typeof ns === 'object' && key in ns) {
					ns[key] = value;
					break;
				}
			}
		}
		acc[locale] = nested;
		return acc;
	}, {});
	strings.setContent(merged);
	if (currentLang) strings.setLanguage(currentLang);
};

const LANG_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

export function langCacheKey(app) {
	return `lang_config_${app}`;
}

export function readLangCache(app) {
	try {
		const raw = localStorage.getItem(langCacheKey(app));
		if (!raw) return null;
		const {data, ts} = JSON.parse(raw);
		if (Date.now() - ts > LANG_CACHE_TTL_MS) {
			localStorage.removeItem(langCacheKey(app));
			return null;
		}
		return data;
	} catch {
		return null;
	}
}

export function writeLangCache(app, data) {
	try {
		localStorage.setItem(langCacheKey(app), JSON.stringify({data, ts: Date.now()}));
	} catch {
		// localStorage full or unavailable — silently skip
	}
}

export default strings;
